// extracted by mini-css-extract-plugin
export var brand = "_b9-9";
export var compact = "_b9-6";
export var extraSmall = "_b9-7";
export var icon = "_b9-0";
export var large = "_b9-4";
export var light = "_b9-1";
export var medium = "_b9-5";
export var outline = "_b9-b";
export var primaryDark = "_b9-a";
export var primaryLight = "_b9-8";
export var primaryModern = "_b9-c";
export var success = "_b9-2";
export var successSolid = "_b9-3";